// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__kEncE","spinner":"Spinner_spinner__Qz7DP","rotate":"Spinner_rotate__CI1qn"};